module.exports = __webpack_public_path__ + "assets/img/202108-5.c1487749.png";